import React from 'react';
import PropTypes from 'prop-types';

const Select = ({
  id, placeHolder, options, multi,
}) => (
  <select name={id} id={id} className="news-events-select" multiple={multi}>
    {!multi && (
      <option value="1">{placeHolder}</option>
    )}
    {options.map(option => (
      <option key={option} value={option}>{option}</option>
    ))}
  </select>
);

export default Select;

Select.defaultProps = {
  multi: false,
};

Select.propTypes = {
  id: PropTypes.string.isRequired,
  placeHolder: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.string,
  ).isRequired,
  multi: PropTypes.bool,
};
